module.exports = __webpack_public_path__ + "assets/images/GrowTalent-logo.7350b21.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/header/GrowTalent-logo.png
// module id = 450
// module chunks = 1